module.exports = __webpack_public_path__ + "img/ERGO_Icon_black_Facebook.aae7ccef.svg";